import React from 'react';
import base from '../base';
import axios from 'axios';
import he from 'he';
import Header from './ui/Header';
import UserLookup from './UserLookup';
import ProductList from './ProductList';
import ProductModal from './ProductModal';
import Bookings from './Bookings';
import BookingsModal from './BookingsModal';
import LiveEvents from './LiveEvents';
import LiveEventModal from './LiveEventModal';
import TabGroup from './ui/TabGroup';
import Login from './Login';
import moment from 'moment';

class App extends React.Component{

    state = {
        products: {},
        globalSettings: {},
        liveEvents: {},
        eventModalId: null,
        newEvent: false,
        bookings: {},
        bookingsModalId: null,
        newBooking: false,
        access_token: '',
        productSearch: '',
        userProductSearch: '',
        productModalId: null,
        newProduct: false,
        currentTab: 'User lookup',
        uid: null,
        disableUserLookup: false,
        is_email: null,
        is_user: {},
        is_user_appts: [],
        payments: {},
        freshdeskID: ''
    };

    componentDidMount = () => {
        base.onAuth((user) => {
          if(user) {
            this.authHandler(null, {user});
          }
        });

        const url = new URL(window.location.href);
        let email = url.searchParams.get("lookup");
        if(email && email !== "undefined"){
            this.lookupUser(email);
        }
    };

    componentWillUnmount = () => {
        base.removeBinding(this.productsRef);
        base.removeBinding(this.settingsRef);
        base.removeBinding(this.infusionsoftRef);
        base.removeBinding(this.liveEventsRef);
        base.removeBinding(this.bookingsRef);
        this.logout();
    };

    login = (username, password) => {
        base.authWithPassword({email: username, password: password}, this.authHandler);
    };

    authHandler = (err, authData) => {
        if(err){
            console.log(err);
            return;
        } else {
            let uid = authData.user.uid;
            this.setState({ uid, currentTab: 'User lookup' });

            this.productsRef = base.syncState(`products`, {
                context: this,
                state: 'products'
            });

            this.settingsRef = base.syncState(`globalSettings`, {
                context: this,
                state: 'globalSettings'
            });

            this.infusionsoftRef = base.syncState(`infusionsoft/access_token`, {
                context: this,
                state: 'access_token'
            });

            this.liveEventsRef = base.syncState(`liveEvents`, {
                context: this,
                state: 'liveEvents'
            });

            this.bookingsRef = base.syncState(`bookings`, {
                context: this,
                state: 'bookings'
            });
        }
    };

    logout = () => {
        base.unauth();
        this.setState({
            uid: null,
            products: {},
            globalSettings: {},
            access_token: ''
        });
    };

    showProductModal = (productId) => {
        this.setState({
            productModalId: productId,
            newProduct: false
        });
    };

    closeProductModal = () => {
        this.setState({
            productModalId: null
        });
    };

    addProduct = () => {
        const products = {...this.state.products};
        const timestamp = Date.now();
        products[timestamp] = {progressBar: "true"};
        //console.log(products);
        this.setState({ products, productModalId: timestamp, newProduct: true });
    };

    updateProduct = (product, productKey) => {
        const products = {...this.state.products};
        products[productKey] = product;
        this.setState({ products, productModalId: null, newProduct: false });
    };

    deleteProduct = (productKey) => {
        const deleteProd = confirm("Are you sure you want to delete this product?");
        if (deleteProd) {
            const products = {...this.state.products};
            products[productKey] = null;
            this.setState({ products, productModalId: null, newProduct: false });
        }
    };

    filterProducts = (e, key) => {
        this.setState({ [key]: e.target.value });
    };

    getFilteredProducts = (filter) => {
        const products = {...this.state.products};
        const searchTerm = filter.toLowerCase();
        for (const product in products) {
            if(products.hasOwnProperty(product)) {
                if(products[product].title){
                    const title = products[product].title.toLowerCase();
                    if(!title.includes(searchTerm) ) {
                        delete products[product];
                    }
                } else {
                    delete products[product];
                }

            }
        }
        return products;
    };

    updateProductOfTheMonth = (productKey) => {
        const globalSettings = {...this.state.globalSettings};
        globalSettings.productOfTheMonth = this.state.products[productKey].title;
        this.setState({ globalSettings });
    };

    showEventModal = (eventId) => {
        this.setState({
            eventModalId: eventId,
            newEvent: false
        });
    };

    closeEventModal = () => {
        this.setState({
            eventModalId: null
        });
    };

    addEvent = () => {
        const liveEvents = {...this.state.liveEvents};
        const timestamp = String(Date.now());
        liveEvents[timestamp] = {};
        console.log(liveEvents);
        this.setState({ liveEvents, eventModalId: timestamp, newEvent: true });
    };

    updateEvent = (event, eventKey) => {
        const liveEvents = {...this.state.liveEvents};
        liveEvents[eventKey] = event;
        this.setState({ liveEvents, eventModalId: null, newEvent: false });
    };

    deleteEvent = (eventKey) => {
        const deleteEventQ = confirm("Are you sure you want to delete this event?");
        if (deleteEventQ) {
            const liveEvents = {...this.state.liveEvents};
            liveEvents[eventKey] = null;
            this.setState({ liveEvents,  eventModalId: null, newEvent: false });
        }
    };

    showBookingsModal = (bookingId) => {
        this.setState({
            bookingsModalId: bookingId,
            newBooking: false
        });
    };

    closeBookingsModal = () => {
        this.setState({
            bookingsModalId: null
        });
    };

    addBooking = () => {
        const bookings = {...this.state.bookings};
        const timestamp = String(Date.now());
        bookings[timestamp] = {};
        this.setState({ bookings, bookingsModalId: timestamp, newBooking: true });
    };

    updateBooking = (booking, bookingKey) => {
        const bookings = {...this.state.bookings};
        bookings[bookingKey] = booking;
        this.setState({ bookings, bookingsModalId: null, newBooking: false });
    };

    deleteBooking = (bookingKey) => {
        const deleteBookingQ = confirm("Are you sure you want to delete this booking?");
        if (deleteBookingQ) {
            const bookings = {...this.state.bookings};
            bookings[bookingKey] = null;
            this.setState({ bookings,  bookingsModalId: null, newBooking: false });
        }
    };

    lookupUser = (email) => {
        this.setState({ disableUserLookup: true, is_email: email, is_user: {} });
        this.getUserData(email);
    };

    getUserData = (email) => {
        const d = Date.now();
        axios({
            method: 'post',
            url: `https://us-central1-intuitive-sensitives-admin.cloudfunctions.net/getuser`,
            headers: { 'Content-Type': 'application/json' },
            data: { "key": "hjcgehjkcbehabwlecbwejh767dgwecjkb434yujhcebhjevyutt37", "email": email }
        })
        .then(res => {
            this.setState({
                is_user: res.data,
                disableUserLookup: false
            });

            if(!res.data.userFound) {
                this.setState({ is_user: {} });
                alert('No user found with that email address');
            }

            console.log('Took ' + ((Date.now() - d) / 1000)  + ' seconds');
            this.getAppts(res.data);
            this.getPayments(res.data, res => {
                this.processPaymentList(res);
            });

            this.getFreshdeskUser(res.data.Email);
        });
    };

    getFreshdeskUser = (email) => {
        if(email){
            axios({
                url: `https://heidisawyer.freshdesk.com/api/v2/search/contacts?query="email:'${he.encode(email)}'"`,
                method: 'get',
                headers: { 'Content-Type': 'application/json', Authorization: 'Basic N3ExeHc0b2dzbW9OZTJaVnhScTpY' }
            }).then(response => {
                if( response && response.data && response.data.results && response.data.results[0] && response.data.results[0].id ){
                    this.setState({ freshdeskID: `${response.data.results[0].id}` });
                }
                else {
                    this.setState({ freshdeskID: '' });
                }
            });
        }
        else {
            this.setState({ freshdeskID: '' });
        }
    };

    getAppts = (is_user, callback = null) => {
        axios({
            url: "https://us-central1-intuitive-sensitives-admin.cloudfunctions.net/getappts",
            headers: { 'Content-Type': 'application/json' },
            method: 'post',
            data: JSON.stringify({
              "key": "hjcgehjkcbehabwlecbwejh767dgwecjkb434yujhcebhjevyutt37",
              "Id": is_user.Id
            })
        }).then(response => {
            let appts = [];
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(response.data,"text/xml");
            Array.from(xmlDoc.getElementsByTagName('struct')).forEach((struct, index) => {
                appts[index] = {};
                Array.from(struct.getElementsByTagName('member')).forEach(member => {
                    if(member.firstChild.textContent === 'CreationNotes'){
                        appts[index][member.firstChild.textContent] = he.decode(member.lastChild.textContent);
                    } else {
                        appts[index][member.firstChild.textContent] = member.lastChild.textContent;
                    }
                });
            });
            this.setState({ is_user_appts: appts });
            if(callback != null){
              callback(response.data);
            }
        });
    };


    editTags = (productKey, mode) => {
        const tagsForAccess = this.state.products[productKey].tagsForAccess.split(',');

        if(tagsForAccess && tagsForAccess.length === 1){
            const data = {
                "key": "hjcgehjkcbehabwlecbwejh767dgwecjkb434yujhcebhjevyutt37",
                "id": this.state.is_user.Id,
                "tag": tagsForAccess[0],
                "mode": mode
            };
            axios({
                method: 'post',
                url: `https://us-central1-intuitive-sensitives-admin.cloudfunctions.net/changetags`,
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify(data)
            }).then(res => {
                const is_user = {...this.state.is_user};

                if(mode === "addToGroup") {
                    is_user.tags.push(tagsForAccess[0]);
                } else {
                    is_user.tags.splice( is_user.tags.indexOf(tagsForAccess[0]), 1);
                }

                this.setState({ is_user });
            });
          }
    };

    addTags = (productKey) => {
        this.editTags(productKey, 'addToGroup');
    }

    removeTags = (productKey) => {
        this.editTags(productKey, 'removeFromGroup');
    }

    changeTab = (tab) => {
        this.setState({ currentTab: tab });
    };

    renderProductModal = () => {
        if(this.state.productModalId) {
            return (
                <ProductModal
                product={this.state.products[this.state.productModalId]}
                productKey={this.state.productModalId}
                closeProductModal={this.closeProductModal}
                updateProduct={this.updateProduct}
                deleteProduct={this.deleteProduct}
                newProduct={this.state.newProduct}
                />
            );
        }
        return null;
    };

    renderEventModal = () => {
        if(this.state.eventModalId) {
            return (
                <LiveEventModal
                event={this.state.liveEvents[this.state.eventModalId]}
                eventKey={this.state.eventModalId}
                updateEvent={this.updateEvent}
                deleteEvent={this.deleteEvent}
                newEvent={this.state.newEvent}
                closeLiveEventModal={this.closeEventModal}
                />
            );
        }
        return null;
    };

    renderBookingsModal = () => {
        if(this.state.bookingsModalId) {
            return (
                <BookingsModal
                booking={this.state.bookings[this.state.bookingsModalId]}
                bookingKey={this.state.bookingsModalId}
                updateBooking={this.updateBooking}
                deleteBooking={this.deleteBooking}
                newBooking={this.state.newBooking}
                closeBookingModal={this.closeBookingsModal}
                />
            );
        }
        return null;
    };


    renderPages = () => {
        switch(this.state.currentTab) {
            case 'User lookup':
                return <UserLookup lookupUser={this.lookupUser} disableUserLookup={this.state.disableUserLookup} user={this.state.is_user} products={this.getFilteredProducts(this.state.userProductSearch)} renderTags={this.renderTags} addTags={this.addTags} removeTags={this.removeTags} filterProducts={this.filterProducts} userProductSearch={this.state.userProductSearch} appts={this.state.is_user_appts} payments={this.state.payments}
                freshdeskID={this.state.freshdeskID}/>
            case 'Products':
                return <ProductList products={this.getFilteredProducts(this.state.productSearch)} showProductModal={productId => this.showProductModal(productId)} addProduct={this.addProduct} deleteProduct={this.deleteProduct} filterProducts={this.filterProducts} productSearch={this.state.productSearch} updateProductOfTheMonth={this.updateProductOfTheMonth} globalSettings={this.state.globalSettings} renderTags={this.renderTags}/>
            case 'Live events':
                return <LiveEvents events={this.state.liveEvents} addEvent={this.addEvent} showEventModal={eventId => this.showEventModal(eventId)} />
            case 'Bookings':
                return <Bookings bookings={this.state.bookings} addBooking={this.addBooking} showBookingsModal={bookingId => this.showBookingsModal(bookingId)}/>
            default:
                return null;
        }
    };

    processTags = (tags, allowAccess) => {
        let processedTags = [];
        if(tags){
            const tagArray = tags.replace(" ", "").split(",");
            processedTags = tagArray.map(tag => {
                return <span key={tag} className={`tag ${allowAccess ? '' : 'denyTag'}`}>{(allowAccess ? '' : '-') + tag}</span>;
            });
        }
        return processedTags;
    };

    renderTags = (accessTags, denyTags) => {
        const tagArray = this.processTags(accessTags, true);
        const denyTagArray = this.processTags(denyTags, false);
        return tagArray.concat(denyTagArray);
    };

    getPayments = (is_user, callback = null) => {
        if(is_user.userFound){
            axios({
                url: "https://us-central1-intuitive-sensitives-admin.cloudfunctions.net/getpayments",
                headers: { 'Content-Type': 'application/json' },
                method: 'post',
                data: JSON.stringify({
                  "key": "hjcgehjkcbehabwlecbwejh767dgwecjkb434yujhcebhjevyutt37",
                  "Id": is_user.Id,
                })
            }).then(function(response) {
                if(callback != null){
                  callback(response.data);
                }
            });
        }
    };

    processPaymentList = (payments) => {
        let totalValue = 0;
        const dates = [];
        const values = [];
        let firstDate;

        if(payments[0] && payments[0].PayDate){
            firstDate = moment(payments[0].PayDate, "YYYYMMDDTHH:mm:ss").format('YYYY-MM');

            while( moment(firstDate, "YYYY-MM").isSameOrBefore( moment(), 'month' ) ){
                dates.push( firstDate );
                values.push(0);
                firstDate = moment(firstDate, "YYYY-MM").add(1, 'months').format("YYYY-MM");
            }
        }

        Object.keys(payments).forEach(function(payment, index){
            if(payments[payment].PayType !== "Credit" && payments[payment].PayType !== "Write-off"){
                totalValue += Number(payments[payment].PayAmt);

                var dateIndex = dates.indexOf( moment(payments[payment].PayDate, "YYYYMMDDTHH:mm:ss").format("YYYY-MM") );
                values[dateIndex] += Number(payments[payment].PayAmt);
            }
        });

        this.setState({
            payments: {
                dates,
                values,
                totalValue
            }
        });
    };


    render() {
        if(this.state.uid === null) {
            return (
                <div>
                    <Header auth={this.state.uid} login={this.login} logout={this.logout} />
                    <Login login={this.login} />
                </div>
            );
        } else {
            return (
                <div>
                    <div className="no-print">
                        <Header auth={this.state.uid} login={this.login} logout={this.logout} />
                        <TabGroup tabs={['User lookup', 'Products', 'Live events', 'Bookings']} currentTab={this.state.currentTab} onChange={this.changeTab} />
                    </div>
                    <div className="wrapper">
                        {this.renderPages()}
                    </div>
                    {this.renderProductModal()}
                    {this.renderEventModal()}
                    {this.renderBookingsModal()}
                </div>
            );
        }
    }
}

App.contextTypes = {
    router: React.PropTypes.object
}

export default App;


/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/